const intersectionFix = (item: any) => {
  item.eventId = (item.params || {}).eventId;
  delete item.target;
  item._finalAdd = true;
  return item;
};

export default intersectionFix;
